/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var notEmpty = function notEmpty(x) {
  return !!x;
};
function _default() {
  return [].slice.call(arguments).filter(notEmpty).join(' ');
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/join.js
// module id = 82
// module chunks = 0